import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import copy from 'copy-to-clipboard'
const styles = theme => ({
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4,
  },
});

class CopyLinkSnackbar extends React.Component {
  state = {
    open: true,
    timeout: null,
    message: "Copy registration link"
  };

  handleClick = () => {
    this.setState({ ...this.state, timeout: null, open: true });
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ ...this.state, timeout: null, open: false });
  };
  handleCopy = (textToCopy, afterCopyMessage) => {
    const self = this;
    return function () {
      copy(textToCopy);
      self.setState({ ...self.state, message: afterCopyMessage, timeout: 5000 })
    }
  }
  render() {
    const { isChecked, textToCopy, afterCopyMessage } = this.props;
    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          autoHideDuration={this.state.timeout}
          open={this.state.open && isChecked}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{this.state.message}</span>}
          action={[
            <Button key="undo" color="secondary" size="small" onClick={this.handleCopy(textToCopy, afterCopyMessage)}>
              COPY
            </Button>,
          ]}
        />
      </div>
    );
  }
}

CopyLinkSnackbar.propTypes = {
  classes: PropTypes.object.isRequired,
  isChecked: PropTypes.bool.isRequired,
  textToCopy: PropTypes.string.isRequired,
  afterCopyMessage: PropTypes.string.isRequired
};

export default withStyles(styles)(CopyLinkSnackbar);


// WEBPACK FOOTER //
// ./src/components/copy-link-snackbar.js